<template>
  <div class="row taxon-search-panel" :id="taxonSearchPanelId" v-bind:style="{ borderColor : backgroundColor}">
    <form class="form col-12">

      <div class="form-row">
        <div class="col mr-4"><h5>Survey</h5></div>
        <div class="col border-left ml-4"><h5>Taxonomy</h5></div>
      </div>


      <div class="form-row">
        <div class="col-1" style="text-align: right">Name</div>
        <div class="col mr-4">
          <select v-model="datasetName" class="form-control" :id="datasetSelectorId"
                  @change="datasetChanged($event)">
            <option v-for="option in datasetNames" v-bind:key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
        <div class="col-1 border-left ml-4" style="text-align: right">Rank</div>
        <div class="col">
          <select v-model="rank" class="form-control">
            <option v-for="option in ranks" v-bind:key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="col-1" style="text-align: right">Date</div>
        <div class="col mr-4">
          <div class="input-group input-daterange">
            <b-form-datepicker :date-format-options="{ year: 'numeric'}" :id="dateStartId" v-model="dateStart"/>
            <div class="input-group-addon" style="margin-left: 2em; margin-right: 2em">to</div>
            <b-form-datepicker :date-format-options="{ year: 'numeric'}" :id="dateEndId" v-model="dateEnd"/>
          </div>
        </div>
        <div class="col-1 border-left ml-4" style="text-align: right">Taxon</div>
        <div class="col">
          <div class="mt-3">Autocompletion</div>
          <VueTypeaheadBootstrap
              v-model="taxon"
              :ieCloseFix="false"
              :data="taxonProposals"
              :serializer="taxonProposals => taxonProposals.name"
              @hit="taxonSelectionCompleted"
              :minMatchingChars="3"
              placeholder="Taxon Name"
              @input="getTaxonProposals"
          />
          <div class="mt-3">Search in Taxonomic Tree</div>
          <treeselect
              v-model="taxon"
              :multiple="false"
              :options="taxonomicTree"
              placeholder="Select your favourite(s)..."
              @select="treeSelectionCompleted"

          />
        </div>

      </div>

      <div class="form-row mt-2">
        <div class="col"></div>
        <div class="col-2 ml-5" style="text-align: right">
          <b-button variant="info" v-on:click="displayRefreshDashboard" :disabled="!this.displayable">
            {{ displayRefreshLabel }}
          </b-button>
        </div>
        <div class="col-2 ml-5" style="text-align: left">
          <b-button variant="danger" v-on:click="removePanel" :disabled="!this.removable">Remove Panel</b-button>
        </div>
        <div class="col"></div>
      </div>
    </form>
  </div>
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import axios from "axios";
import {mapActions, mapGetters} from "vuex";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ApiCall} from "../mixins/ApiMixin";

export default {
  name: "TaxonSelectorPanel",

  props: ["panelId", "backgroundColor", "removable", "refreshDisplayLabel", "settings"],

  mixins: [ApiCall],

  components: {
    VueTypeaheadBootstrap,
    Treeselect,
  },

  data() {
    return {
      taxonomicTree: [],

      displayRefreshLabel: 'Generate Dashboard',
      displayable: false,

      taxonSearchPanelId: 'taxon-search-panel-' + this.panelId,
      datasetSelectorId: 'dataset-selector-' + this.panelId,
      dateStartId: 'date-start-' + this.panelId,
      dateEndId: 'date-end-' + this.panelId,

      datasetNames: [],
      datasetName: null,
      datasetType: null,

      dateStart: null,
      dateEnd: null,

      ranks: [],
      rank: null,

      taxon: null,
      taxonProposals: [],
    }
  },

  created() {
    this.getDatasetNames()

  },
  watch: {
    dateStart(){
      if (this.taxon){
        this.displayable = true
      }
    },
    dateEnd(){
      if (this.taxon){
        this.displayable = true
      }
    }
  },
  computed: {
    ...mapGetters([
      'getTaxonInfoFromPanel',
    ]),

  },

  methods: {
    ...mapActions([
      'taxonSearchPanelUpdated',
    ]),
    getTaxonomicTree() {

      axios
          .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['taxonomic_tree', this.datasetName]))
          .then(response => {
            this.taxonomicTree = response.data
          })
          .catch(function (error) {
            console.warn("Unable to retrieve taxonomic tree related to dataset : " + error);
          })
    },


    getDatasetNames: function () {
      let me = this
      axios
          .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['dataset_names']))
          .then(response => {
            this.datasetNames = response.data
            if (me.settings['restore']) {
              me.datasetName = me.settings['dataset']
            } else {
              me.datasetName = me.datasetNames[0].value
            }
            this.datasetChanged(null)
          })
          .catch(function (error) {
            console.warn("Unable to retrieve dataset names: " + error);
          })
    },

    /*
      When the selected dataset changes, this method updates the date input fields as well as
      the rank selector.
      Called either when the user selects a new dataset OR when the panel is created (in this case, the event
      argument is null and the name of the dataset has already been stored in this.datasetName.
     */
    datasetChanged: function (event) {
      if (event != null) {
        this.datasetName = event.target.value;
      }
      this.getDatasetType();
      this.getTaxonomyRanks();
      this.getTaxonomicTree();
      this.getDateRange();

    },

    getTaxonomyRanks: function () {
      if (this.datasetName) {
        let me = this;
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['taxonomy_ranks', me.datasetName]))
            .then(response => {
              me.ranks = response.data;
              if (me.settings['restore']) {
                me.rank = me.settings['rank']
                me.taxon = me.settings['taxon']
              } else {
                me.rank = me.ranks[me.ranks.length - 1].value
                me.taxon = ''
              }
              me.taxonProposals = []
            })
            .catch(function (error) {
              console.warn("Error when trying to retrieve taxonomy ranks for dataset '" + me.datasetName + "': " + error);
              me.ranks = [];
            })
      }
    },

    getDateRange: function () {
      if (this.datasetName) {
        let me = this;
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['dates', me.datasetName]))
            .then(response => {
              if (me.settings['restore']) {
                me.dateStart = me.settings['dateStart']
                me.dateEnd = me.settings['dateEnd']
              } else {
                me.dateStart = response.data['date_start']
                me.dateEnd = response.data['date_end']
              }
            })
            .catch(function (error) {
              console.warn("Error when trying to retrieve date range for dataset '" + me.datasetName + "': " + error);
              me.dateStart = '1901-01-01'
              me.dateEnd = '2999-12-31'
            })
      }

    },

    getTaxonProposals: function () {
      if (this.rank && this.taxon) {
        let me = this;
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['taxon_proposals',
            this.rank, this.taxon, this.datasetName]))
            .then(function (response) {
              me.taxonProposals = response.data;
            })
            .catch(function (error) {
              console.warn("Error trying to retrieve taxon proposals: " + error);
              me.taxonProposals = [];
            });
      }
    },

    getDatasetType: function () {
      if (this.datasetName) {
        let me = this;
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['dataset_type', this.datasetName]))
            .then(function (response) {
              me.datasetType = response.data;
            })
            .catch(function (error) {
              console.warn("Error trying to retrieve dataset type: " + error);
              me.datasetType = "Temporal";
            });
      }
    },

    removePanel() {
      /* Signal SearchPanel parent component that this TaxonSelectorPanel needs to be removed. */
      this.$emit('remove-panel', this.panelId)
    },


    taxonSelectionCompleted: function (taxon) {
      this.taxon = taxon.id
      this.displayable = true
    },
    treeSelectionCompleted() {
      this.displayable = true

    },

    displayRefreshDashboard: function () {
      if (this.displayable) {
        let payload = {
          "panelId": this.panelId,
          "dataset": this.datasetName,
          "rank": this.rank,
          "taxon": this.taxon,
          "dateStart": this.dateStart,
          "dateEnd": this.dateEnd,
          "backgroundColor": this.backgroundColor,
          "type": this.datasetType
        }
        this.taxonSearchPanelUpdated(payload)
        this.displayRefreshLabel = 'Update Dashboard'
        this.displayable = false
      }
    },
  },
}

</script>

<style scoped>
.taxon-search-panel {
  border-width: 6px;
  border-style: solid;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-bottom: 4px;
  text-align: center;
}
</style>